import React from 'react';
import { Star } from 'lucide-react';
const comments = [{
  quote: 'Ya no siento que todo depende de mí. Mis hermanos y yo por fin hablamos el mismo idioma.',
  name: 'Sofía V.',
  role: 'Hija, Perú'
}, {
  quote: 'Por fin logramos organizarnos como familia. El tomo de comunicación nos cambió las cenas de los domingos.',
  name: 'Daniela P.',
  role: 'Hija, Argentina'
}, {
  quote: 'Esto me dio claridad en un momento muy difícil. No sabía por dónde empezar y el sistema me guió paso a paso.',
  name: 'Gabriela S.',
  role: 'Hija, Colombia'
}, {
  quote: 'Pensé que era solo consejos, pero son herramientas reales. Los protocolos de crisis nos salvaron la semana pasada.',
  name: 'Fernanda L.',
  role: 'Hija, México'
}, {
  quote: 'Logré poner límites sin sentirme culpable. Ahora acompaño a mi mamá con mucho más amor y menos estrés.',
  name: 'Claudia M.',
  role: 'Hija, Ecuador'
}, {
  quote: 'La organización de documentos nos ahorró muchísimos problemas legales que no veíamos venir.',
  name: 'Verónica R.',
  role: 'Hija, Chile'
}];
export function TestimonialsPreGuarantee() {
  return <section className="bg-brand-dark py-5 px-5" data-id="element-306">
      <div className="max-w-xl mx-auto" data-id="element-307">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-white mb-2" data-id="element-308">
          🗣️ Familias reales, resultados reales
        </h2>
        <p className="text-sm text-gray-500 text-center mb-8" data-id="element-309">
          Esto dicen quienes ya aplican el sistema en sus hogares o familias
        </p>

        <div className="space-y-3" data-id="element-310">
          {comments.map((c, i) => <div key={i} className="bg-gray-900 border border-gray-800 p-4 rounded-xl" data-id="element-311">
              <div className="flex gap-0.5 mb-2" data-id="element-312">
                {[...Array(5)].map((_, j) => <Star key={j} size={12} className="fill-brand-yellow text-brand-yellow" data-id="element-313" />)}
              </div>
              <p className="text-gray-300 italic text-sm mb-2 leading-relaxed" data-id="element-314">
                "{c.quote}"
              </p>
              <div className="flex items-center gap-2" data-id="element-315">
                <div className="w-7 h-7 rounded-full bg-gray-700 flex items-center justify-center text-xs font-bold text-brand-yellow flex-shrink-0" data-id="element-316">
                  {c.name.charAt(0)}
                </div>
                <div data-id="element-317">
                  <p className="font-bold text-white text-xs" data-id="element-318">{c.name}</p>
                  <p className="text-[11px] text-gray-500" data-id="element-319">{c.role}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}